<template>
    <component :is="name.toLowerCase()" />
</template>

<script>
    import SpringIcon from './spring-icon.vue';
    import SummerIcon from './summer-icon.vue';
    import FallIcon from './fall-icon.vue';
    import WinterIcon from './winter-icon.vue';

    export default {
        props: {
            name: {
                type: String,
                default: '',
            }
        },
        components: {
            'spring': SpringIcon,
            'summer': SummerIcon,
            'fall': FallIcon,
            'winter': WinterIcon,
        },
    }
</script>
